<template>
    <div>
        <v-dialog
            v-model="show"
            max-width="500"
            scrollable
        >
            <v-card v-if="card">
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{card.cardtype_name}}
                    <v-spacer />
                    <v-btn icon @click="show = false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols=4>
                            <v-auto-img :src="card.cardtype.imagekey" />
                        </v-col>
                        <v-col cols=8>
                            <TrainingCardProductInfo :product="card.cardtype" />
                        </v-col>

                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex flex-wrap">
                    <v-btn
                        v-if="canCancelCard"
                        @click="showCancelCardDialog = true"
                        color="error"
                        style="margin-right: 0.3em;"
                    >{{$translate('Cancel card')}}</v-btn>

                    <zoezi-collection-receipt v-if="showReceiptBtn" :cards="[card]" style="overflow: hidden; min-width: 110px;" />
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="showCancelCardDialog"
            max-width="500"
            scrollable
        >
            <v-card>
                <v-card-title class="headline pa-2 primary primarytext--text d-flex fill-width">
                    {{$translate('Cancel {0}').format(card.cardtype_name)}}
                    <v-spacer />
                    <v-btn icon @click="showCancelCardDialog= false" ><v-icon class="primary primarytext--text">mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8">
                            <div v-if="card.validToDate">
                                <v-icon small>mdi-calendar-clock</v-icon>
                                <span> {{$translate('Valid until')}} {{Date.formatFullShort(card.validToDate) + ' ' + Date.newFull(card.validToDate).getFullYear()}}</span>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-textarea
                    v-model="reason"
                    class="ml-4 mr-4"
                    :label="$translate('Please tell us why you want to cancel the training card')"
                >
                </v-textarea>
                <div style="text-align:center" >
                    <v-btn
                        :loading="loading"
                        @click="cancelTrainingCard(card)"
                        style="display:inline-block; width:100px"
                        color="error"
                        class="ma-4"
                    >
                        {{$translate('Cancel card')}}
                    </v-btn>
                    <v-btn
                        dark
                        @click="showCancelCardDialog = false"
                        style="display:inline-block; width:100px"
                        class="ma-4"
                    >
                        {{$translate('Cancel')}}
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ZoeziCollectionReceipt from '../views/CollectionReceipt.vue'
import TrainingCardProductInfo from './TrainingCardProductInfo.vue';

export default {
    name: 'zoezi-training-card-dialog',

    props: ['value', 'card'],

    components: {
        ZoeziCollectionReceipt,
        TrainingCardProductInfo
    },

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.show = value;
            }
        },
        show(value) {
            this.$emit('input', value);
        }
    },

    data: () => ({
        show: false,
        showCancelCardDialog: false,
        reason:null,
        loading:false,
        gettingReceipt: false
    }),

    computed: {
        canCancelCard() {
            return this.$store.state.settings?.canCancel && this.card.boundToDate && !this.card.validToDate && !(this.card.parent_trainingcard_id && this.$api.hasFlag('flag-package-trainingcard')) && (this.$store.state.user.id == this.card.user_id || this.$store.state.user.canManage.find(x => x.id == this.card.user_id));
        },
        showReceiptBtn() {
            return this.$store.state.user.id == this.card.user_id || this.$store.state.user.canManage.find(x => x.id == this.card.user_id);
        }
    },

    methods:{
        cancelTrainingCard(card){
            this.loading = true;
            this.$api.post('/api/memberapi/trainingcard/cancel', {id: card.id, reason: this.reason}).then(() => {
                this.loading = false;
                this.showCancelCardDialog = false;
            });
        }
    }
}
</script>
